// extracted by mini-css-extract-plugin
export default {"settings-form":"OkjLhd8rGBI4OanwlB8S"};